import { InvoiceDetailsNotice } from "../pages/Billing/BillingInvoiceDetails";
import React, { useRef } from "react";
import useTrialStatusRefresh from "../Hooks/useTrialStatusRefresh";
import ClubBillingNotice from "./ClubBillingNotice";
import { BILLING_ROUTE } from "../routes";
import { isClubAdmin } from "../utility/Utils";
import { getCurrentLoadedBilling } from "../pages/Billing/billingAccessPolicy";

export default function ClubFreeAccessAnnouncement({ user, billingState, onRefreshBilling, pathname }) {
  const billing = getCurrentLoadedBilling(billingState, user?.club?._id);
  const refreshScope = isClubAdmin(user) && user?._id && user?.club?._id
    ? `${user._id}:${user.club._id}` : null;
  const invoiceAccess = useRef({ scope: null, allowed: false });
  const failure = billingState?.error;
  const denied = [401, 403].includes(failure?.statusCode || failure?.response?.status) ||
    failure?.codes?.some(code => ["FORBIDDEN_BILLING_ACCESS", "FORBIDDEN_CLUB_ACCESS", "UNAUTHORIZED_CLUB_ACCESS",
      "BILLING_ROLLOUT_DISABLED", "UNAUTHENTICATED", "UNAUTHORIZED", "FORBIDDEN"].includes(code));
  if (invoiceAccess.current.scope !== refreshScope || !refreshScope ||
      String(billingState?.clubId) !== String(user?.club?._id) || denied ||
      (!billing && !billingState?.loading && !failure)) {
    invoiceAccess.current = { scope: refreshScope, allowed: false };
  }
  if (billing && !denied) invoiceAccess.current = { scope: refreshScope,
    allowed: billing.billingEnabled === true && billing.canManageBilling === true };
  useTrialStatusRefresh(refreshScope ? billing : null, onRefreshBilling, {
    scopeKey: refreshScope,
    retry: Boolean(refreshScope && String(billingState?.clubId) === String(user.club._id) &&
      billingState?.error && !billingState?.loading),
    loading: Boolean(refreshScope && String(billingState?.clubId) === String(user.club._id) && billingState?.loading),
  });
  if (!isClubAdmin(user) || !user?._id) return null;
  const onBillingRoute = pathname === BILLING_ROUTE || pathname?.startsWith(`${BILLING_ROUTE}/`);
  const invoiceNotice = !onBillingRoute && invoiceAccess.current.allowed
    ? <InvoiceDetailsNotice key={`invoice:${refreshScope}`} clubId={String(user.club._id)} userId={String(user._id)} /> : null;
  if (!billing) return <>{invoiceNotice}</>;
  if (billing.billingEnabled !== true) return null;
  // Suppress notices while the Billing route hands off an action or returns.
  if (onBillingRoute) return null;
  const restricted = ["read_only", "inactive"].includes(billing.billingAccessMode);
  const actionableFullAccess = billing.billingAccessMode === "full" && billing.canViewBilling === true && (
    ["past_due", "unpaid", "incomplete", "paused", "canceled", "incomplete_expired"].includes(billing.status) ||
    (billing.cancelAtPeriodEnd && ["active", "trialing"].includes(billing.status)) ||
    (!billing.trialStartedLocally && ["not_started", "started_no_subscription"].includes(billing.billingState) && billing.nextAction === "checkout")
  );
  // Keep the invoice poller mounted during same-scope billing refreshes.
  // Active-trial notices and countdowns are delivered by Intercom.
  return <>{invoiceNotice}{!billingState?.loading && (restricted || actionableFullAccess) &&
    <ClubBillingNotice key={`billing:${user._id}:${billing.clubId}`} billing={billing} onRefreshBilling={onRefreshBilling} />}</>;
}
